import React, { FC } from 'react';
import { Route, useLocation } from 'react-router-dom';
import DashboardWrap from '../../../components/DashboardWrap';
import { AdminRouteName } from '../../CONSTANTS';
// import RolesAndPermissionGuard from '../../../components/RolesAndPermissionGuard';
import ProductPreferenceMain from './ProductPreferenceMain';
import './productPreference.scss';

const ProductPreference: FC = () => {
  const location = useLocation();
  return (
    <DashboardWrap>
      {/* <RolesAndPermissionGuard permissionName=""> */}
      <div className="product-preference-root">
        <Route
          component={ProductPreferenceMain}
          path={AdminRouteName.customerProductPreferenceRoute}
          exact
        />
        <Route
          component={ProductPreferenceMain}
          path={AdminRouteName.customerProductPreferenceStatusRoute}
          exact
          key={location.pathname}
        />
      </div>
      {/* </RolesAndPermissionGuard> */}
    </DashboardWrap>
  );
};

export default ProductPreference;
